import React, { useState, useEffect } from 'react';
import Supporting from '../components/Footer/Supporting';
import TopInformation from '../components/Header/TopInformation';
import AppRelease from '../components/Header/AppRelease';
import { connect } from 'react-redux';
import { donePageLoading } from '../actions/offer';
import { useTranslation, Trans } from "react-i18next";

function Prepair(props) {
	const { t } = useTranslation();

	const sortType = 'date';
	// お知らせ表示
	const [isInformation, setIsInformation] = useState(false);
	const [isInformationCalled, setIsInformationCalled] = useState(false);

	const isAppInfoVisibility = (process.env.REACT_APP_APP_RELEASE_INFORMATION_VISIVILITY === "true") ? true : false ;
	const isInfoVisibility = (process.env.REACT_APP_INFORMATION_VISIVILITY === "true") ? true : false ;
	const isSponserVisibility = (process.env.REACT_APP_SPONSER_VISIVILITY === "true") ? true : false ;
	
	// Get JSON file(お知らせ)
	useEffect(() => {
		if(!isInformationCalled) {
			setIsInformationCalled(true);
			const url = process.env.REACT_APP_API_DIR_URL + `v1/static/information`;
			fetch(url)
			.then(response => {
				if (!response.ok || response.status !== 200) {
					throw new Error(response.statusText);
				}
				return response.json()
			})
			.then(data => {
				if (data.length <= 0) {
					setIsInformation(false);
					return;
				}
				window.topics = data;
				setIsInformation(true);
			})
			.catch(error => {
				console.log(error);
				setIsInformation(false);
			});
		}
	}, [isInformationCalled]);

	props.donePageLoading(true);

	return (
		<>
		<style>
		{`
			.guide {
				padding: 52px 0px 120px !important;
				text-align: center;
				font-size: 16px;
			}
			.guide-section {
				max-width: 100% !important;
				text-align: center;
			}
			.guide-title { border-bottom: none; font-size: 2.0em; font-family:serif;}
			.guide-text { font-weight: normal; line-height: 2.0em; font-size: 1.2em; padding-bottom:1.5em;}
			.guide-text span { font-weight: bold; }
			.guide-text.black { width:80%; background-color: #0004; padding: 2rem; border-radius: 1rem; margin: 4rem 10%; }
			.guide-section p { line-height: 2.0em; }
			.guide-linkbox {
				padding: 2rem;
				width: 80%;
				margin: 4rem 10%;
			}
			.guide-linkbox a {
				text-decoration: none;
				color: white;
				font-weight: bold;
				font-size: 2rem;
			}
			@media screen and (max-width: 900px) {
				.guide { font-size: 14px;}
				.guide-linkbox a { font-size: 1.6rem; }
				.guide-linkbox { width: 100%; margin: 0; padding: 0.5rem; }
				.guide-text.black { width: 100%; padding: 1rem; margin: 4rem 0; }
			}
			@media screen and (max-width: 640px) {
				.guide { font-size: 12px;}
				.guide-linkbox a { font-size: 1.2rem; }
				.guide-linkbox { width: 100%; margin: 0; padding: 0.5rem; }
				.guide-text.black { width: 100%; padding: 1rem; margin: 4rem 0; }
			}
			@media screen and (max-width: 480px) {
				.guide { font-size: 10px; }
				.guide-linkbox a { font-size: 1.0rem; }
				.guide-linkbox { width: 100%; margin: 0; }
			}
		`}
			</style>
			{isInfoVisibility && isInformation ? <TopInformation language={props.language} topics={window.topics}/> : ''}
			{isAppInfoVisibility ? <AppRelease language={props.language} /> : ''}
			<section className="home">
				<div className="home__inner">
					<section className="guide" id="guide-basic">
						<h1 className="common-title">{t("prepair.title")}</h1>
						<section className="guide-section">
							<p className="guide-text"><Trans i18nKey="prepair.guideText" /></p>
							<div className="guide-linkbox"><Trans i18nKey="prepair.guideLinkbox" components={{ l: <a href={t("prepair.linkOfficialSite")} target="_blank">link</a> }}/></div>
							<p className="guide-text black"><Trans i18nKey="prepair.guideTextBlack" components={{ l: <a href={t("prepair.linkMypage")} target="_blank">link</a> }}/></p>
						</section>
					</section>
				</div>
			</section>
			{isSponserVisibility == true && <Supporting sortType={sortType} />}
		</>
	);
}

const mapStateToProps = state => {
	return {
		language: state.piano.language,
	};
};

const mapDispatchToProps = dispatch => ({
	donePageLoading: state => dispatch(donePageLoading(state)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Prepair);

